import styled from "styled-components";

const Body = styled.div`
  padding: var(--ads-v2-spaces-7);
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;
`;

export default Body;
